/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';

import Content13 from './Content13';
import Pricing2 from './Pricing2';

import {
  Content130DataSource,
  Pricing20DataSource,
  Pricing21DataSource,
  Pricing22DataSource,
  Pricing23DataSource,
  Pricing24DataSource,
  Pricing25DataSource,
  Pricing26DataSource,
} from './data.source';
import './less/antMotionStyle.less';

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

const { location = {} } = typeof window !== 'undefined' ? window : {};

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile,
      show: !location.port, // 如果不是 dva 2.0 请删除
    };
  }

  componentDidMount() {
    // 适配手机屏幕;
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
    // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
    /* 如果不是 dva 2.0 请删除 start */
    if (location.port) {
      // 样式 build 时间在 200-300ms 之间;
      setTimeout(() => {
        this.setState({
          show: true,
        });
      }, 500);
    }
    /* 如果不是 dva 2.0 请删除 end */
  }

  render() {
    const children = [
      <Content13
        id="Content13_0"
        key="Content13_0"
        dataSource={Content130DataSource}
        isMobile={this.state.isMobile}
      />,
      // <Pricing2
      //   id="Pricing2_0"
      //   key="Pricing2_0"
      //   dataSource={Pricing20DataSource}
      //   isMobile={this.state.isMobile}
      // />,
      // <Pricing2
      //   id="Pricing2_1"
      //   key="Pricing2_1"
      //   dataSource={Pricing21DataSource}
      //   isMobile={this.state.isMobile}
      // />,
      // <Pricing2
      //   id="Pricing2_2"
      //   key="Pricing2_2"
      //   dataSource={Pricing22DataSource}
      //   isMobile={this.state.isMobile}
      // />,
      // <Pricing2
      //   id="Pricing2_3"
      //   key="Pricing2_3"
      //   dataSource={Pricing23DataSource}
      //   isMobile={this.state.isMobile}
      // />,
      // <Pricing2
      //   id="Pricing2_4"
      //   key="Pricing2_4"
      //   dataSource={Pricing24DataSource}
      //   isMobile={this.state.isMobile}
      // />,
      // <Pricing2
      //   id="Pricing2_5"
      //   key="Pricing2_5"
      //   dataSource={Pricing25DataSource}
      //   isMobile={this.state.isMobile}
      // />,
      // <Pricing2
      //   id="Pricing2_6"
      //   key="Pricing2_6"
      //   dataSource={Pricing26DataSource}
      //   isMobile={this.state.isMobile}
      // />,
    ];
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      >
        {/* 如果不是 dva 2.0 替换成 {children} start */}
        {this.state.show && children}
        {/* 如果不是 dva 2.0 替换成 {children} end */}
      </div>
    );
  }
}
